import React from 'react';
import {Anchor, Breadcrumbs} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import S from './Article1.module.scss';
import article1 from "../../shared/assets/images/article1.png";
import article2 from "../../shared/assets/images/article2.png";
import article3 from "../../shared/assets/images/article3.png";
import article4 from "../../shared/assets/images/article4.png";

export const Article1 = () => {
    const navigate = useNavigate();

    const items = [
        { title: 'Главная', url: '/' },
        { title: 'Статьи', url: '/articles-list' },
        { title: 'Статья', active: true },
    ].map((item, index) => (
        <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
            {item.title}
        </Anchor>
    ));
    return (
        <section id='article1'>
            <div className={S.content}>
                <div>
                    <Breadcrumbs>
                        {items}
                    </Breadcrumbs>
                    <div className={S.infoDiv}>
                        <div className={S.title}>ОЛЬГА КАЛАШНИКОВА, НАЧАЛЬНИК УПРАВЛЕНИЯ ЭКОЛОГИИ ПАО «СЕВЕРСТАЛЬ»: «БУДУЩЕЕ
                            ПРИНАДЛЕЖИТ ТЕМ, КТО ГОТОВИТСЯ К НЕМУ СЕГОДНЯ, СЛЕДУЯ ЭКОЛОГИЧЕСКИМ ПРИНЦИПАМ»</div>
                        <div className={S.picture}>
                            <img src={article1} alt="article1"/>
                        </div>
                        <div className={S.textDiv}>
                            <div className={S.text}>
                                Экологизация промышленных городов России направлена на снижение негативного воздействия
                                на окружающую среду и улучшение качества жизни населения. Для эффективной экологизации
                                необходим комплексный подход, объединяющий усилия государства, бизнеса и общества. О
                                направлениях работы ПАО «Северсталь» в рамках поставленной задачи, достигнутых эффектах
                                от внедрения экомероприятий, об особенностях промышленных городов и реализации
                                федерального проекта «Чистый воздух», в интервью с Ольгой Калашниковой, начальником
                                управления экологии ПАО «Северсталь».
                            </div>
                            <div className={S.textBold}>
                                Решение экологических проблем промышленных городов требует комплексного подхода. На ваш
                                взгляд, на какие из аспектов необходимо обратить внимание в первую очередь?
                            </div>
                            <div className={S.text}>
                                Для того, чтобы оставаться конкурентоспособным на рынке, конечно, необходимо
                                технологическое развитие предприятия, но не менее важно реализовывать образовательные
                                экологические проекты, которые наглядно будут демонстрировать усилия компании в области
                                решения экологических проблем.
                            </div>
                            <div className={S.text}>
                                Так, например, управлением коммуникаций реализуется проект — «Чистая металлургия», в
                                рамках которого на промышленную площадку предприятия приглашаются представители
                                общественных организаций, жители города, активисты, которые видят все те крупные проекты
                                по технологическому перевооружению предприятия, о которых сложно рассказать словами.
                            </div>
                            <div className={S.text}>
                                Кроме того, в Череповце работает уникальный созданный «Музей металлургической
                                промышленности», в котором гости города знакомятся с деятельностью предприятия, в том
                                числе в отношении экологии.
                            </div>
                            <div className={S.text}>
                                При этом весомую часть при решении экологических проблем составляет
                                образовательно-просветительская работа с молодым поколением.
                            </div>
                            <div className={S.textBold}>
                                Иногда для успешной работы по экологизации производства в промышленных городах требуется
                                обмен опытом и технологиями между различными регионами/предприятиями. Взаимодействуют ли
                                между собой производственные объекты ПАО «Северсталь»?
                            </div>
                            <div className={S.text}>
                                Да, предприятия «Северстали» и всей группы компаний «Севергрупп» интенсивно
                                взаимодействуют друг с другом в рамках программы «Синергия»:
                            </div>
                            <div className={S.text}>
                                <div className={S.liDiv}>
                                    <li/>
                                    регулярно проводятся онлайн- и офлайн встречи;
                                </div>
                                <div className={S.liDiv}>
                                    <li/>
                                    происходит обмен наилучшими практиками и технологическими решениями;
                                </div>
                                <div className={S.liDiv}>
                                    <li/>
                                    проводят дискуссии по вопросам подготовки кадров, предложений к регуляторам, выбору
                                    партнеров и подрядчиков.
                                </div>
                            </div>
                            <div className={S.text}>
                                Более того, к участию в подобных встречах экологи «Северстали» стараются привлекать
                                коллег из других компаний, научных институтов и вузов, региональных органов
                                исполнительной власти и муниципальных организаций.
                            </div>
                            <div className={S.text}>
                                В частности, в 2024 году состоялись коммуникационные встречи экологов «Севергрупп»,
                                посвященные проблемам получения КЭР, ППЭЭ, различным отраслевым практикам, проведению
                                субботников и пр. Также был проведен круглый стол, посвященный очистке сточных, шахтных
                                и дренажных вод на промышленных предприятиях (более 80 участников).
                            </div>
                            <div className={S.text}>
                                Кроме того, активно развивается всероссийское экспертное сообщество «Энергетика и
                                экология», в котором уже состоят сотни участников из группы компаний «Севергрупп», иных
                                российских компаний и ряда зарубежных компаний.
                            </div>
                            <div className={S.hrefDiv}>
                                <span className={S.textBold}>Продолжение статьи по ссылке:</span>
                                <a href="https://journal.ecostandard.ru/eco/intervyu/olga-kalashnikova-nachalnik-upravleniya-ekologii-pao-severstal-budushchee-prinadlezhit-tem-kto-gotov/"
                                >https://journal.ecostandard.ru/eco/intervyu/olga-kalashnikova-nachalnik-upravleniya-ekologii-pao-severstal-budushchee-prinadlezhit-tem-kto-gotov/</a>
                            </div>
                            <div className={S.hrefDiv}>
                                <span className={S.textBold}>Источник:</span>
                                <a href="ecostandardgroup.ru"
                                >ecostandardgroup.ru</a>
                            </div>
                        </div>
                        <div className={S.articleTitleDiv}>Читайте также</div>
                        <div className={S.articlesDiv}>
                            <div className={S.articleDiv} onClick={() => navigate('/article2')}>
                                <div className={S.pictureArticle}>
                                    <img src={article2} alt="article2"/>
                                </div>
                                <div className={S.articleDivText}>Цифровизация экономических отношений в энергетике</div>
                                <p className={S.articleDivDate}>24.04.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article3')}>
                                <div className={S.pictureArticle}>
                                    <img src={article3} alt="article3"/>
                                </div>
                                <div className={S.articleDivText}>Ум, сталь и трубы нашей эпохи</div>
                                <p className={S.articleDivDate}>25.06.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article4')}>
                                <div className={S.pictureArticle}>
                                    <img src={article4} alt="article4"/>
                                </div>
                                <div className={S.articleDivText}>Цифровизация в обучении ремонтников Уральской Стали</div>
                                <p className={S.articleDivDate}>23.12.2024</p>
                            </div>
                        </div>
                    </div>
                    <div className={S.footer}>
                        <div onClick={() => navigate('/articles-list')}>← Назад к списку</div>
                    </div>
                </div>
            </div>
        </section>
    );
};